export const formatDateToLocal = (strDate: string) => {
  if (!strDate) return undefined;

  const date = new Date(`${strDate}+00:00`);
  return date;
};
